import { useEffect, memo } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop: React.FC = memo(() => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [pathname]);

  return null;
});

ScrollToTop.displayName = 'ScrollToTop';

export default ScrollToTop;

